// extracted by mini-css-extract-plugin
module.exports = {"errorMessageBox":"errorMessage_errorMessageBox__ujyb_","icon":"errorMessage_icon__IO2og","message":"errorMessage_message__EgsMG"};